export const POINT_GROUPS = [
  { key: 'cubic', label: 'Cubic' },
  { key: 'hexagonal', label: 'Hexagonal' },
  { key: 'trigonal', label: 'Trigonal' },
  { key: 'tetragonal', label: 'Tetragonal' },
  { key: 'orthorhombic', label: 'Orthorhombic' },
  { key: 'monoclinic', label: 'Monoclinic' },
  { key: 'triclinic', label: 'Triclinic' }
]

export const POINT_TYPES = [
  { key: 'm3m', label: 'm3m', group: 'cubic' },
  { key: '-43m', label: '-43m', group: 'cubic' },
  { key: '432', label: '432', group: 'cubic' },
  { key: 'm3', label: 'm3', group: 'cubic' },
  { key: '23', label: '23', group: 'cubic' },

  { key: '6/mmm', label: '6/mmm', group: 'hexagonal' },
  { key: '-6m2', label: '-6m2', group: 'hexagonal' },
  { key: '6mm', label: '6mm', group: 'hexagonal' },
  { key: '622', label: '622', group: 'hexagonal' },
  { key: '6/m', label: '6/m', group: 'hexagonal' },
  { key: '-6', label: '-6', group: 'hexagonal' },
  { key: '6', label: '6', group: 'hexagonal' },

  { key: '-32/m', label: '-32/m', group: 'trigonal' },
  { key: '3m', label: '3m', group: 'trigonal' },
  { key: '32', label: '32', group: 'trigonal' },
  { key: '-3', label: '-3', group: 'trigonal' },
  { key: '3', label: '3', group: 'trigonal' },

  { key: '4/mmm', label: '4/mmm', group: 'tetragonal' },
  { key: '-42m', label: '-42m', group: 'tetragonal' },
  { key: '4mm', label: '4mm', group: 'tetragonal' },
  { key: '422', label: '422', group: 'tetragonal' },
  { key: '4/m', label: '4/m', group: 'tetragonal' },
  { key: '-4', label: '-4', group: 'tetragonal' },
  { key: '4', label: '4', group: 'tetragonal' },

  { key: 'mmm', label: 'mmm', group: 'orthorhombic' },
  { key: 'mm2', label: 'mm2', group: 'orthorhombic' },
  { key: '222', label: '222', group: 'orthorhombic' },

  { key: '2/m', label: '2/m', group: 'monoclinic' },
  { key: 'm', label: 'm', group: 'monoclinic' },
  { key: '2', label: '2', group: 'monoclinic' },

  { key: '-1', label: '-1', group: 'triclinic' },
  { key: '1', label: '1', group: 'triclinic' }
]

// 晶族
export const CRYSTAL_CLUSTERS = [
  { key: 'l', label: '低级晶族' },
  { key: 'm', label: '中级晶族' },
  { key: 'h', label: '高级晶族' }
]

// 晶系
export const CRYSTAL_SYS = [
  { key: '3i', label: '三斜晶系' },
  { key: '1i', label: '单斜晶系' },
  { key: 'i', label: '斜方晶系' },
  { key: '3s', label: '三方晶系' },
  { key: '4s', label: '四方晶系' },
  { key: '6s', label: '六方晶系' },
  { key: 'ep', label: '等轴晶系' }
]


// WEBPACK FOOTER //
// ./src/constants/cvts.js